import { TableRow, TableCell, ButtonBase } from "@material-ui/core";
import React, { useState } from "react";
import { RowProps } from "./RowProps";
import { ReactComponent as ChevronDown } from "icons/ChevronDown.svg";
import { ReactComponent as ChevronUp } from "icons/ChevronUp.svg";
import { rowStyles } from "./RowStyles";

export default function Row<T>({
    columns,
    data,
    expandable,
    expandableContent,
}: RowProps<T>) {
    const classes = rowStyles();

    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded((expanded) => !expanded);

    return (
        <React.Fragment>
            <TableRow>
                {columns.map((column) => (
                    <TableCell
                        key={column.id}
                        className={classes.cell}
                        align={column.align}
                    >
                        {column.render ? column.render(data) : data[column.id]}
                    </TableCell>
                ))}
                {expandable && (
                    <TableCell className={classes.expandCell}>
                        <ButtonBase
                            onClick={toggleExpanded}
                            className={classes.expandButton}
                        >
                            {expanded ? <ChevronUp /> : <ChevronDown />}
                        </ButtonBase>
                    </TableCell>
                )}
            </TableRow>
            {expandable && expanded && expandableContent && (
                <TableRow>
                    <TableCell
                        style={{
                            backgroundColor: "rgba(39, 10, 220, 0.02)",
                        }}
                        colSpan={7}
                    >
                        {expandableContent(data)}
                    </TableCell>
                </TableRow>
            )}
        </React.Fragment>
    );
}
